import { memo } from 'react';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, IconButton, Tooltip } from '@mui/material';

interface ChoiceActionProps {
    moveDownDisabled: boolean;
    moveUpDisabled: boolean;
    canDeleteChoice: boolean;
    removeOption: () => void;
    moveUp: () => void;
    moveDown: () => void;
}

const ChoiceActionButtons = ({
    moveDownDisabled,
    moveUpDisabled,
    canDeleteChoice,
    removeOption,
    moveUp,
    moveDown,
}: ChoiceActionProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <IconButton
                disabled={moveUpDisabled}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    moveUp();
                }}
                size="small"
            >
                <KeyboardArrowUpIcon />
            </IconButton>
            <IconButton
                disabled={moveDownDisabled}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    moveDown();
                }}
                size="small"
            >
                <KeyboardArrowDownIcon />
            </IconButton>
            <Tooltip title="Delete option?" placement="left-start">
                <IconButton
                    size="small"
                    color="error"
                    sx={{ position: 'absolute', top: 0, right: 0, zIndex: 1000 }}
                    disabled={!canDeleteChoice}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        removeOption();
                    }}
                >
                    <DeleteOutlineIcon fontSize="small" color="error" />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default memo(ChoiceActionButtons);
